//
// This component is a legacy component that still needs to be broken out and refactored.
//
// The following should be done in future:
//
//   The startup code which reads the stored LocalStorage values, updates them if required and then
//     adds the values to the store should be added to a service. The Base Map and Map Layers
//     related code should live in the map-style and map-layer services respectively. THIS HAS BEEN
//     COMPLETED. Code relating to weather and user settings should exist in perhaps a new weather
//     service and the user service respectively. USER SETTINGS HAS BEEN COMPLETED. The weather
//     service should also own the weather-layout configuration. WEATHER HAS BEEN MOVED.
//

import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import { transitionToNextRoute } from '../services/route/route-navigation';
import { ROUTE_ONBOARDING } from '../services/route/route-names';
import { SIGN_UP_URL } from '../services/route/permissions';
import { telemetry } from '../services/backend';

import PageHolder from '../components/containers/PageHolder/PageHolder';
import Router from '../components/shared/Router/Router';
import classNames from 'classnames/bind';
import styles from './routes.scss';
import ConnectedPopover from '../components/containers/AppControls/ConnectedPopover';

/* eslint-disable max-len */

const cx = classNames.bind(styles);

class Routes extends React.Component {
  constructor(props) {
    super(props);

    this.checkIfOnboardingIsCompleted = async () => {
      const { member, location } = this.props;

      /**
       * Redirect to onboarding if:
       * 1. User is logged in
       * 2. User is verified
       * 3. User hasn't completed onboarding
       * 4. User isn't already in onboarding flow
       */
      if (
        member &&
        member.verified &&
        !member.isOnBoardingComplete &&
        location.pathname !== SIGN_UP_URL
      ) {
        telemetry(telemetry.DEBUG, 'Redirecting to OnBoardingComplete');
        // Redirect to onboarding
        transitionToNextRoute(ROUTE_ONBOARDING);
      }
    };
  }

  async componentDidMount() {
    this.checkIfOnboardingIsCompleted();
  }

  componentDidUpdate(prevProps /* prevState */) {
    const { location, member } = this.props;

    // Check if onboarding has been completed when member or route changes
    if (
      member !== prevProps.member ||
      location.key !== prevProps.location.key
    ) {
      this.checkIfOnboardingIsCompleted();
    }
  }

  render() {
    const { pageHolderTransparent } = this.props;

    telemetry(telemetry.DEBUG, 'Content is rendering');

    return (
      <PageHolder>
        <div
          className={cx('routes__page-holder-children')}
          style={{
            pointerEvents: pageHolderTransparent ? 'none' : 'all',
          }}
        >
          <ConnectedPopover />
          {/* child components are rendered by our router
          this should not be confused for react-router.
          Our router uses react-router switch and route to render
          the correct child components. */}
          <Router />
        </div>
      </PageHolder>
    );
  }
}

Routes.propTypes = {
  location: PropTypes.shape({
    key: PropTypes.string,
    pathname: PropTypes.string,
  }).isRequired,
  pageHolderTransparent: PropTypes.bool.isRequired,

  member: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    verified: PropTypes.bool,
    isOnBoardingComplete: PropTypes.bool,
  }),
};

Routes.defaultProps = {
  member: {},
};

const mapStateToProps = (state) => ({
  // Map our app controls config for the route
  pageHolderTransparent: state.appControls.pageHolderTransparent,
  member: state.backendService.currentMember,
});

// connect will map redux state to the component
// withRouter will map the router context to the component (for location)
export default connect(mapStateToProps)(withRouter(Routes));
